'use strict'
import api from '@/api/api'
import notify from "@/utils/notify"

export default {
  async getOrders(params = {}) {
    // params: { page, per_page, search }
    const query = new URLSearchParams()
    if (params.page) query.set('page', params.page)
    if (params.per_page) query.set('per_page', params.per_page)
    if (params.search) query.set('search', params.search)

    const data = {
      method: 'get',
      url: `orders${query.toString() ? `?${query.toString()}` : ''}`,
    }

    const response = await api.api(data)
    if (response.status === 200) {
      return response.data
    }
  },
  async getOrder(id) {
    const data = {
      method: 'get',
      url: 'order/' + id,
    }

    const response = await api.api(data)
    if (response.status === 200) {
      return response.data
    }
  },
  async getOrderDetails(id, params = {}) {
    const query = new URLSearchParams()
    if (params.page) query.set('page', params.page)
    if (params.per_page) query.set('per_page', params.per_page)
    if (params.search) query.set('search', params.search)

    const data = {
      method: 'get',
      url: `order/${id}/details${query.toString() ? `?${query.toString()}` : ''}`,
    }

    const response = await api.api(data)
    if (response.status === 200) {
      return response.data
    }
    return {data: [], total: 0}
  },
  async createOrderDetails(json) {
    const data = {
      method: 'post',
      url: 'order-details',
      body: json,
    }

    const response = await api.api(data)
    if (response.status === 201) {
      notify.alert.success('Order product added', 2000)
      return true;
    }
  },
  async updateOrderDetails(json, id) {
    const data = {
      method: 'put',
      url: 'order-details/' + id,
      body: json,
    }

    const response = await api.api(data)
    if (response.status === 200) {
      notify.alert.success('Order product updated', 2000)
      return true;
    }
  },
  async deleteOrderDetails(id) {
    const data = {
      method: 'delete',
      url: 'order-details/' + id
    }

    const response = await api.api(data)
    if (response.status === 200) {
      notify.alert.success('Order product deleted', 2000)
      return true;
    }
  },
  async changeOrderStatus(body, id) {
    const data = {
      method: 'patch',
      url: 'order-status/' + id,
      body: body,
    }

    const response = await api.api(data)
    if (response.status === 200) {
      notify.alert.success('Order submitted successfully')
      window.location.reload();
    }
  },
}
